import React from 'react';

import './Status.css';

function Status({ text = 'Payment is pending' }) {
  return (
    <div className="instapay_status">
      <p className='instapay_status_content'>{text}</p>
    </div>
  );
}

export default Status;
